// Otrokovické letní slavnosti - Data

export const festivalInfo = {
  name: "Otrokovické letní slavnosti",
  subtitle: "Staňte se součástí jednoho z největších letních festivalů ve Zlínském kraji",
  date: "10.–11. července 2026",
  location: "Otrokovice – park před Společenským domem",
  entrance: "VSTUP ZDARMA",
  eventId: "otrokovicke-letni-slavnosti-2026"
};

export const heroImage = "https://vseproakci.cz/wp-content/uploads/2025/06/OLS-pic.jpg";

export const aboutFestival = [
  "Dvoudenní městský festival",
  "Očekávaná návštěvnost: několik tisíc lidí",
  "Program pro rodiny, mladé i starší návštěvníky",
  "Koncerty známých interpretů",
  "Sportovní a freetime zóna",
  "Dětský program",
  "Gastro a festivalové bary",
  "Velmi dobrá dostupnost v centru města"
];

export const whyJoinReasons = [
  {
    icon: "Users",
    title: "Velká návštěvnost",
    description: "Očekávaná návštěvnost 5000+ během dvou festivalových dnů"
  },
  {
    icon: "MapPin",
    title: "Centrum města",
    description: "Festival v centru Otrokovic s vynikající dostupností"
  },
  {
    icon: "Clock",
    title: "Pestrý program",
    description: "Atraktivní program přivádějící návštěvníky po celý den"
  },
  {
    icon: "CheckCircle2",
    title: "Profesionální organizace",
    description: "Zkušený tým a kvalitní festivalové zázemí"
  },
  {
    icon: "Heart",
    title: "Propagace akce",
    description: "Rozsáhlá propagace městem Otrokovice a partnery"
  }
];

export const vendorCategories = {
  priority: {
    title: "Food Trucks a velké stánky",
    description: "Hledáme zkušené prodejce s kvalitním gastro vybavením",
    requirements: [
      "Burgery, BBQ, grilované speciality",
      "Mexická a asijská kuchyně",
      "Street food speciality",
      "Kvalitní vybavení a prezentace"
    ],
    reason: "Festival klade důraz na kvalitní a pestrou gastronomickou nabídku"
  },
  additional: {
    title: "Sladké a doplňkový sortiment",
    categories: [
      "Palačinky, churros, wafle",
      "Zmrzlina a dezerty",
      "Specialitní nápoje a limonády",
      "Regionální produkty",
      "Drobný festivalový sortiment"
    ]
  }
};

export const whatWeOffer = [
  "Prodejní místo v areálu festivalu",
  "Přístup k elektřině (dle domluvy)",
  "Zázemí pro prodejce",
  "Propagaci akce",
  "Organizovanou gastro zónu",
  "Velký pohyb návštěvníků"
];

export const scheduleInfo = {
  date: "10.–11. července 2026",
  hours: {
    friday: "16:30 – 24:00",
    saturday: "14:30 – 01:00"
  },
  setup: "V den akce podle pokynů pořadatele"
};

export const venueInfo = {
  city: "Otrokovice",
  mainLocation: "Park před Společenským domem",
  zones: [
    "Hlavní stage",
    "Gastro zóna",
    "Dětská zóna"
  ]
};

export const programSchedule = {
  friday: [
    {
      artist: "Sebastian",
      videoUrl: "https://www.youtube.com/embed/pvpIN5A4WRU",
      description: "Jeden z nejpopulárnějších českých interpretů"
    },
    {
      artist: "Best of Rock",
      description: "Rocková show plná energie"
    },
    {
      artist: "Lenny",
      videoUrl: "https://www.youtube.com/embed/kmq8tz2erXs",
      description: "Česká zpěvačka s unikátním hlasem"
    },
    {
      artist: "Room Service – Bryan Adams Tribute",
      description: "Tribute Bryan Adams"
    }
  ],
  saturday: [
    {
      artist: "Moravská Veselka",
      description: "Tradiční moravská muzika"
    },
    {
      artist: "The Best of Meky",
      description: "Nejlepší hity Mira Žbirky"
    },
    {
      artist: "Barbora Poláková",
      videoUrl: "https://www.youtube.com/embed/o7auqhgjgig",
      description: "Oblíbená česká zpěvačka"
    },
    {
      artist: "Petr Bende Band",
      videoUrl: "https://www.youtube.com/embed/mwI4HpnX6lY",
      description: "Populární slovenský interpret"
    },
    {
      artist: "Kosovci",
      description: "Legendární slovenská kapela"
    }
  ]
};

export const pricingInfo = {
  mainVendors: {
    pricePerDay: 9000,
    title: "Food trucky/stánky s jídlem",
    size: "Stánek do 6x3m",
    description: "Hlavní prodej - Food trucky a stánky s jídlem"
  },
  otherVendors: {
    pricePerDay: 2800,
    title: "Ostatní prodejci",
    size: "Stánek max. 3x3m",
    description: "Sladké, pochutiny, výrobky"
  },
  electricity: {
    title: "Energie",
    options: [
      { range: "230V max 3,5 kW", price: "1.750 Kč" },
      { range: "16A/380V (3f) - 3,5kW až 6kW", price: "3.300 Kč" },
      { range: "32A/380V (3f) - 6kW až 12 kW", price: "4.500 Kč" }
    ],
    note: "Cena za celou akci"
  },
  note: "Všechny ceny jsou uvedeny bez DPH"
};

export const contactInfo = {
  organizers: [
    {
      name: "Město Otrokovice",
      logo: "https://www.otrokovice.cz/images/logo.png"
    },
    {
      name: "Otrokovická Beseda",
      logo: "https://www.otrokovickabeseda.cz/images/logo.png"
    }
  ],
  contactPerson: {
    name: "Jakub Vodárek",
    phone: "774 750 456",
    email: "info@vseproakci.cz"
  },
  website: "vseproakci.cz"
};

export const importantRules = [
  "Prodejce musí disponovat platným živnostenským oprávněním",
  "Dodržování hygienických předpisů je povinné",
  "Prodejce je povinen mít uzavřené pojištění odpovědnosti za škodu",
  "Sortiment musí být schválen organizátorem",
  "Prodejce se zavazuje k důstojné prezentaci svého stánku",
  "Dodržování protipožárních předpisů"
];
